// extracted by mini-css-extract-plugin
export default {"container":"_32x98","titleRow":"+UuKr","title":"_4OVSA","viewItems":"Js3ee","spreadRow":"Xkgdp","total":"kSaIh"};